import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutesUrl } from "../../common/consts/Routes";
import { find, findAndUpdate, store } from "../../services/service";
import CardComponent from "../shared/CardComponent";
import FormComponent, { FormData } from "../shared/test";

function NewClient() {
    let { id }: any = useParams();
    const { push } = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<FormData>({
        dds: false,
        dynamicRows: [] as any,
    });
    useEffect(() => {
        if (id) {
            setIsLoading(true);
            find("clients", id)
                .then((val) => {
                    if (!!!val?.dynamicRows) {
                        val['dynamicRows'] = [];
                    }
                    setFormData(val);
                })
                .finally(() => setIsLoading(false));
        } else {
            setFormData({
                dds: false,
                dynamicRows: [] as any,
            });
        }
    }, [id]);
    console.log(formData);
    return (
        <Box>
            <CardComponent title={`New Client`} isLoading={isLoading}>
                <FormComponent
                    staticFields={[
                        {
                            name: "name",
                            label: "Име",
                            type: "text",
                            required: true,
                            validation: (v) => {
                                if (!v) {
                                    return "Полето е задължително!";
                                }
                            },
                        },
                        { name: "eik", label: "ЕИК", type: "text", required: false },
                        {
                            name: "dds",
                            label: "Регистрация по ДДС ",
                            type: "checkbox",
                            required: false,
                        },
                        {
                            name: "services",
                            label: "Услуги",
                            type: "text",
                            required: false,
                        },
                        {
                            name: "country",
                            label: "Държава",
                            type: "text",
                            required: false,
                        },
                        { name: "address", label: "Адрес", type: "text", required: false },
                        { name: "site", label: "Сайт", type: "text", required: false },
                        { name: "others", label: "Други", type: "text", required: false },
                    ]}
                    dynamicFields={[
                        {
                            name: "name",
                            label: "име",
                            size: 3,
                            type: "text",
                            required: true,
                        },
                        {
                            name: "position",
                            label: "длъжност",
                            size: 3,
                            type: "text",
                            required: false,
                        },
                        {
                            name: "phone",
                            label: "телефон",
                            size: 2,
                            type: "text",
                            required: false,
                        },
                        {
                            name: "email",
                            label: "имейл",
                            size: 2,
                            type: "text",
                            required: false,
                        },
                    ]}
                    dynamicPlural="Лицa за контакт"
                    dynamicSingle="лице за контакт"
                    onSubmit={async (data) => {
                        // TO DO:
                        // Important!
                        console.log("Submitted Data:", data); // Log submitted data

                        try {
                            if (id) {
                                await findAndUpdate("clients", id, data);
                                toast.success("Успешно редактиране");
                                push(RoutesUrl.clients.list);
                                return;
                            }
                            await store("clients", data);
                            toast.success("Успешно добавяне");
                            push(RoutesUrl.clients.list);
                            return true;
                        } catch (e) {
                            toast.error("Нещо се обърка");
                            console.error(e);
                            return false;
                        }
                    }}
                    editMode={id ? true : false}
                    formData={formData}
                    setFormData={setFormData}
                />
            </CardComponent>
        </Box>
    )
}

export default NewClient;